
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/rebekka-borum",
      function () {
        return require("private-next-pages/archive/rebekka-borum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/rebekka-borum"])
      });
    }
  